/**
 * TourBackdrop — dark overlay + amber cutout ring for the OnboardingTour.
 * Two SVG-free layers: (1) dark backdrop with a box-shadow cutout that
 * traces the target rect, (2) a highlight ring positioned on top of the
 * cutout. Both animate their position when `cutout` changes.
 *
 * When `cutout` is null the whole viewport gets a solid backdrop (used
 * for welcome/finale steps that have no target).
 */
export default function TourBackdrop({ cutout }) {
  if (!cutout) {
    return (
      <div
        aria-hidden="true"
        className="fixed inset-0"
        style={{ background: "rgba(15, 20, 25, 0.72)" }}
      />
    );
  }
  const transitionStyle = "top 280ms ease, left 280ms ease, width 280ms ease, height 280ms ease";
  return (
    <>
      <div
        aria-hidden="true"
        style={{
          position: "fixed",
          top: cutout.top,
          left: cutout.left,
          width: cutout.width,
          height: cutout.height,
          borderRadius: 14,
          boxShadow: "0 0 0 9999px rgba(15, 20, 25, 0.72)",
          transition: transitionStyle,
          pointerEvents: "none",
        }}
      />
      <div
        aria-hidden="true"
        style={{
          position: "fixed",
          top: cutout.top,
          left: cutout.left,
          width: cutout.width,
          height: cutout.height,
          borderRadius: 14,
          border: "2px solid #E09E50",
          boxShadow: "0 0 0 4px rgba(224,158,80,0.22)",
          transition: transitionStyle,
          pointerEvents: "none",
        }}
      />
    </>
  );
}
